import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

export const SelectMenuContent: React.FC = () => {
  return (
    <>
      <DropdownMenu.Button id="informational" title="Informational" />
      <DropdownMenu.Button id="commercial" title="Commercial" />
      <DropdownMenu.Button id="transactional" title="Transactional" />
      <DropdownMenu.Button id="navigational" title="Navigational" />
    </>
  )
}
